import React from "react";

const MainTitle: React.FC<{ title: String }> = ({ title }) => {
  return (
    <div className="mb-[80px] relative before:absolute before:-bottom-[50%] before:left-[45%] before:w-[7%] before:h-[3px] before:bg-orange-main after:absolute after:-bottom-[50%] after:left-[52.5%] after:w-[0.3%] after:h-[3px] after:bg-orange-main">
      <h2 className="text-gray-main text-4xl font-bold text-center">{title}</h2>
    </div>
  );
};

const SecondTitle: React.FC<{ title: String }> = ({ title }) => {
  return (
    <div className="mb-[80px] relative before:absolute before:-bottom-[50%]    after:absolute after:-bottom-[50%] after:w-[0.3%] after:h-[3px]">
      <h2 className="text-gray-main text-4xl font-bold text-center">{title}</h2>
    </div>
  );
};

export { MainTitle, SecondTitle };
